module.exports = __webpack_public_path__ + "img/wx_scan_bg.7961e0b4.png";